import React from 'react';
import { Table, Button, Input, Select, Space, Typography } from 'antd';
import { Search, Filter, Edit2, Trash2, ChevronLeft, ChevronRight } from 'lucide-react';

const { Title, Text } = Typography;
const { Option } = Select;

const SettingsRoles = () => {
    const dataSource = [
        {
            key: '1',
            id: '1',
            name: 'Administrator',
            permissionType: 'all',
        }
    ];

    const columns = [
        { title: 'Id', dataIndex: 'id', key: 'id' },
        { title: 'Name', dataIndex: 'name', key: 'name' },
        { title: 'Permission Type', dataIndex: 'permissionType', key: 'permissionType' },
        {
            title: 'Actions',
            key: 'actions',
            align: 'right',
            render: () => (
                <Space size="middle">
                    <Edit2 size={16} color="#6b7280" style={{ cursor: 'pointer' }} />
                    <Trash2 size={16} color="#6b7280" style={{ cursor: 'pointer' }} />
                </Space>
            ),
        },
    ];

    return (
        <div style={{ padding: '24px', backgroundColor: '#fff', minHeight: '100vh', borderRadius: '8px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
                <Title level={3} style={{ margin: 0, fontWeight: 600 }}>Roles</Title>
                <Button type="primary" style={{ backgroundColor: '#2563eb', borderColor: '#2563eb', fontWeight: 500 }}>
                    Create Role
                </Button>
            </div>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                <Space size="large">
                    <Input
                        prefix={<Search size={16} color="#94a3b8" />}
                        placeholder="Search"
                        style={{ width: 300, borderRadius: '6px' }}
                    />
                    <Text type="secondary" style={{ color: '#64748b' }}>1 Results</Text>
                </Space>

                <Space>
                    <Button icon={<Filter size={16} />} style={{ color: '#475569', fontWeight: 500 }}>Filter</Button>
                    <Select defaultValue="10" style={{ width: 120 }}>
                        <Option value="10">10 Per Page</Option>
                        <Option value="20">20 Per Page</Option>
                        <Option value="50">50 Per Page</Option>
                    </Select>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', borderLeft: '1px solid #e2e8f0', paddingLeft: '16px', marginLeft: '8px' }}>
                        <Text style={{ color: '#475569' }}>1 of 1</Text>
                        <Button type="text" size="small" icon={<ChevronLeft size={16} color="#64748b" />} />
                        <Button type="text" size="small" icon={<ChevronRight size={16} color="#64748b" />} />
                    </div>
                </Space>
            </div>

            <Table scroll={{ x: 'max-content' }}
                columns={columns}
                dataSource={dataSource}
                pagination={false}
                bordered={true}
                className="custom-table"
            />
        </div>
    );
};

export default SettingsRoles;
